new Vue({
        el: "#event-generator-app",
        delimiters: ["[[", "]]"],
        data: {
          image:
            document.getElementById("event-generator-app").dataset.defaultImage,
          imageFit: "contain",
          imagePosition: "center",
          imageFileName: "写真が選択されていません",
          heading1: "トンカチトントン",
          heading2: "本棚を作る会",
          syusai: "蔵六湖畔",
          teiin: "なし",
          sankahi: "無料",
          description:
            "蔵六湖畔の本棚になる木箱を、みんなで組み立てるDIYイベントです。釘とトンカチで木箱を組み立てて、72個の木箱が完成したら、本棚ができあがります。棚主さんも、蔵六湖畔が気になっている方も、ふらっと遊びに来てください。\n🌟こんな方におすすめ　・棚主さん　・蔵六湖畔が気になっている方　・DIYをやってみたい方\nDIY経験は不要です。釘を打ったことがなくても、スタッフがやり方をお伝えしますのでご安心ください。\n[ご注意]　トンカチで釘を打つため、会場内には大きな音が響きます。大きな音が苦手な方はご注意ください。",
          mochimono:
            "・汚れてもよい服装\n・軍手（必要な方のみ。こちらでもご用意します。）",
          moushikomi:
            "予約不要です。入退場自由なので、当日ふらっと遊びにきてください。",
          year: "2026",
          month: "06",
          date: "30",
          day: "Tue.",
          hour1: "11",
          minute1: "00",
          hour2: "19",
          minute2: "00",
          days: ["Mon.", "Tue.", "Wed.", "Thu.", "Fri.", "Sat.", "Sun."],
          backgroundColor: "#E8CF4F",
          mainColor: "#17358c",
          rgb: "rgb(232, 207, 79)",
          scale: 1,
          exporting: false,
          savePreviewUrl: "",
          savePreviewFileName: "",
          suppressImageLoad: false,
          resizeObserver: null,
          initialImageLoaded: false,
        },
        computed: {
          hasHeading2() {
            return this.heading2.trim().length > 0;
          },
          startTime: {
            get() {
              return this.hour1 + ":" + this.minute1;
            },
            set(v) {
              let p = (v || "00:00").split(":");
              this.hour1 = p[0];
              this.minute1 = p[1];
            },
          },
          endTime: {
            get() {
              return this.hour2 + ":" + this.minute2;
            },
            set(v) {
              let p = (v || "00:00").split(":");
              this.hour2 = p[0];
              this.minute2 = p[1];
            },
          },
          dateText() {
            return `${this.pad(this.year, 4)}.${this.pad(
              this.month,
            )}.${this.pad(this.date)} ${this.day}  ${this.pad(
              this.hour1,
            )}:${this.pad(this.minute1)}-${this.pad(this.hour2)}:${this.pad(
              this.minute2,
            )}`;
          },
          flyerStyle() {
            return {
              "--paper": this.backgroundColor,
              "--ink": this.mainColor,
              transform: `scale(${this.scale})`,
            };
          },
        },
        mounted() {
          this.resizeObserver = new ResizeObserver(this.updateScale);
          this.resizeObserver.observe(this.$refs.viewport);
          this.updateScale();
        },
        beforeDestroy() {
          if (this.resizeObserver) this.resizeObserver.disconnect();
          if (this.savePreviewUrl) URL.revokeObjectURL(this.savePreviewUrl);
        },
        methods: {
          pad(v, l = 2) {
            return String(v || "").padStart(l, "0");
          },
          updateScale() {
            this.scale = this.$refs.viewport
              ? this.$refs.viewport.clientWidth / 1080
              : 1;
          },
          uploadImage(e) {
            let f = e.target.files && e.target.files[0];
            if (!f) return;
            this.imageFileName = f.name;
            let r = new FileReader();
            r.onload = (x) => {
              this.image = x.target.result;
            };
            r.readAsDataURL(f);
          },
          handleImageLoad() {
            if (this.suppressImageLoad) return;
            if (!this.initialImageLoaded) {
              this.initialImageLoaded = true;
              return;
            }
            this.extractColors(true);
          },
          extractColors(silent = false) {
            let img = this.$el.querySelector(".event-generator-main-visual");
            if (!img || !img.complete) {
              if (!silent) alert("画像の読み込み完了後にお試しください。");
              return;
            }
            try {
              let c = document.createElement("canvas");
              c.width = c.height = 72;
              let x = c.getContext("2d");
              x.drawImage(img, 0, 0, 72, 72);
              let d = x.getImageData(0, 0, 72, 72).data,
                r = 0,
                g = 0,
                b = 0,
                n = 0;
              for (let i = 0; i < d.length; i += 40)
                if (d[i + 3] > 200) {
                  r += d[i];
                  g += d[i + 1];
                  b += d[i + 2];
                  n++;
                }
              if (!n) return;
              r = Math.round(r / n);
              g = Math.round(g / n);
              b = Math.round(b / n);
              this.backgroundColor = this.toHex(r, g, b);
              this.mainColor =
                0.299 * r + 0.587 * g + 0.114 * b > 150 ? "#17358c" : "#f2d77b";
            } catch (e) {
              if (!silent)
                alert(
                  "このURL画像はブラウザの制限により色を抽出できません。手動で色を選択してください。",
                );
            }
          },
          toHex(r, g, b) {
            return (
              "#" +
              [r, g, b].map((v) => v.toString(16).padStart(2, "0")).join("")
            );
          },
          hexToRgb(hex) {
            const value = hex.replace("#", "");
            return [0, 2, 4].map((offset) =>
              parseInt(value.slice(offset, offset + 2), 16),
            );
          },
          tintImage(img, color) {
            const canvas = document.createElement("canvas");
            canvas.width = img.naturalWidth;
            canvas.height = img.naturalHeight;
            const context = canvas.getContext("2d");
            context.drawImage(img, 0, 0);
            const imageData = context.getImageData(
              0,
              0,
              canvas.width,
              canvas.height,
            );
            const [r, g, b] = this.hexToRgb(color);
            for (let i = 0; i < imageData.data.length; i += 4) {
              if (imageData.data[i + 3] === 0) continue;
              imageData.data[i] = r;
              imageData.data[i + 1] = g;
              imageData.data[i + 2] = b;
            }
            context.putImageData(imageData, 0, 0);
            return canvas.toDataURL("image/png");
          },
          rasterizeMainImage(img) {
            const width = 698;
            const height = 873;
            const canvas = document.createElement("canvas");
            canvas.width = width;
            canvas.height = height;
            const context = canvas.getContext("2d");
            const scale =
              this.imageFit === "cover"
                ? Math.max(width / img.naturalWidth, height / img.naturalHeight)
                : Math.min(
                    width / img.naturalWidth,
                    height / img.naturalHeight,
                  );
            const drawWidth = img.naturalWidth * scale;
            const drawHeight = img.naturalHeight * scale;
            const drawX = (width - drawWidth) / 2;
            let drawY = (height - drawHeight) / 2;
            if (this.imagePosition === "top") drawY = 0;
            if (this.imagePosition === "bottom") drawY = height - drawHeight;
            context.clearRect(0, 0, width, height);
            context.drawImage(img, drawX, drawY, drawWidth, drawHeight);
            return canvas.toDataURL("image/png");
          },
          normalizeVerticalText(root) {
            const punctuation = {
              "、": "︑",
              "。": "︒",
              "，": "︐",
              "．": "︒",
              ",": "︐",
              ".": "︒",
              "（": "︵",
              "）": "︶",
              "(": "︵",
              ")": "︶",
              "［": "﹇",
              "］": "﹈",
              "[": "﹇",
              "]": "﹈",
              "「": "﹁",
              "」": "﹂",
              "『": "﹃",
              "』": "﹄",
              "｛": "︷",
              "｝": "︸",
              "{": "︷",
              "}": "︸",
              "：": "︓",
              ":": "︓",
              "；": "︔",
              ";": "︔",
              "ー": "｜",
              "〜": "｜",
              "～": "｜",
            };
            const walker = root.ownerDocument.createTreeWalker(
              root,
              root.ownerDocument.defaultView.NodeFilter.SHOW_TEXT,
            );
            const textNodes = [];
            while (walker.nextNode()) textNodes.push(walker.currentNode);
            textNodes.forEach((node) => {
              node.nodeValue = Array.from(node.nodeValue)
                .map((character) => {
                  if (punctuation[character]) return punctuation[character];
                  const code = character.charCodeAt(0);
                  if (code >= 0x21 && code <= 0x7e) {
                    return String.fromCharCode(code + 0xfee0);
                  }
                  return character;
                })
                .join("");
            });
          },
          closeSavePreview() {
            if (this.savePreviewUrl) URL.revokeObjectURL(this.savePreviewUrl);
            this.savePreviewUrl = "";
            this.savePreviewFileName = "";
          },
          downloadPreviewFile() {
            if (!this.savePreviewUrl) return;
            const a = document.createElement("a");
            a.href = this.savePreviewUrl;
            a.download = this.savePreviewFileName || "event.png";
            a.click();
          },
          async downloadPng() {
            if (typeof html2canvas === "undefined")
              return alert("書き出しライブラリを読み込めませんでした。");
            this.exporting = true;
            let old = this.scale;
            let restoreImages = null;
            this.scale = 1;
            await this.$nextTick();
            try {
              await document.fonts.ready;
              const images = Array.from(
                this.$refs.flyer.querySelectorAll("img"),
              );
              await Promise.all(
                images.map((img) =>
                  typeof img.decode === "function"
                    ? img.decode().catch(() => undefined)
                    : Promise.resolve(),
                ),
              );

              const [paperR, paperG, paperB] = this.hexToRgb(
                this.backgroundColor,
              );
              const exclusionColor = this.toHex(
                255 - paperR,
                255 - paperG,
                255 - paperB,
              );
              const mainRaster = this.rasterizeMainImage(
                this.$el.querySelector(".event-generator-main-visual"),
              );
              const eventRaster = this.tintImage(
                this.$refs.flyer.querySelector(".event-mark"),
                exclusionColor,
              );
              const logoRaster = this.tintImage(
                this.$refs.flyer.querySelector(".logo"),
                exclusionColor,
              );

              const mainElement = this.$el.querySelector(
                ".event-generator-main-visual",
              );
              const eventElement = this.$refs.flyer.querySelector(".event-mark");
              const logoElement = this.$refs.flyer.querySelector(".logo");
              restoreImages = {
                mainElement,
                eventElement,
                logoElement,
                mainSrc: mainElement.src,
                eventSrc: eventElement.src,
                logoSrc: logoElement.src,
                mainObjectFit: mainElement.style.objectFit,
                mainObjectPosition: mainElement.style.objectPosition,
              };

              this.suppressImageLoad = true;
              mainElement.src = mainRaster;
              mainElement.style.objectFit = "fill";
              mainElement.style.objectPosition = "center";
              eventElement.src = eventRaster;
              logoElement.src = logoRaster;
              await Promise.all(
                [mainElement, eventElement, logoElement].map((img) =>
                  typeof img.decode === "function"
                    ? img.decode()
                    : new Promise((resolve, reject) => {
                        img.onload = resolve;
                        img.onerror = reject;
                      }),
                ),
              );

              const prepareClone = (clonedDocument) => {
                const clonedFlyer = clonedDocument.querySelector("#event-generator-flyer");
                clonedFlyer.style.transform = "none";
                clonedFlyer
                  .querySelectorAll("*")
                  .forEach(
                    (element) => (element.style.mixBlendMode = "normal"),
                  );

                clonedFlyer
                  .querySelectorAll(".title-line, .date-band")
                  .forEach((element) => {
                    element.style.setProperty(
                      "background",
                      exclusionColor,
                      "important",
                    );
                  });
                clonedFlyer
                  .querySelectorAll(
                    ".title-line .blend-text, .date-band .blend-text",
                  )
                  .forEach((element) => {
                    element.style.setProperty(
                      "color",
                      this.backgroundColor,
                      "important",
                    );
                  });
                clonedFlyer
                  .querySelectorAll(".meta, .vertical, .venue")
                  .forEach((element) => {
                    element.style.setProperty(
                      "color",
                      exclusionColor,
                      "important",
                    );
                  });
                clonedFlyer
                  .querySelectorAll(".vertical-block")
                  .forEach((element) => {
                    element.style.setProperty(
                      "color",
                      exclusionColor,
                      "important",
                    );
                    element.style.setProperty(
                      "border-color",
                      exclusionColor,
                      "important",
                    );
                  });
                clonedFlyer.querySelectorAll(".vertical").forEach((element) => {
                  element.style.setProperty(
                    "text-orientation",
                    "upright",
                    "important",
                  );
                  this.normalizeVerticalText(element);
                });

                const clonedMain = clonedFlyer.querySelector(".main-image");
                clonedMain.src = mainRaster;
                clonedMain.style.objectFit = "fill";
                const clonedEvent = clonedFlyer.querySelector(".event-mark");
                clonedEvent.src = eventRaster;
                clonedEvent.style.setProperty("top", "-3px", "important");
                clonedEvent.style.setProperty("height", "64px", "important");
                const clonedLogo = clonedFlyer.querySelector(".logo");
                clonedLogo.src = logoRaster;
              };

              const render = async (foreignObjectRendering) => {
                const canvas = await html2canvas(this.$refs.flyer, {
                  width: 1080,
                  height: 1350,
                  scale: 1,
                  useCORS: true,
                  allowTaint: false,
                  foreignObjectRendering,
                  imageTimeout: 15000,
                  backgroundColor: this.backgroundColor,
                  logging: false,
                  onclone: prepareClone,
                });
                return new Promise((resolve, reject) => {
                  try {
                    canvas.toBlob(
                      (blob) =>
                        blob
                          ? resolve(blob)
                          : reject(
                              new Error("PNGデータを生成できませんでした。"),
                            ),
                      "image/png",
                    );
                  } catch (error) {
                    reject(error);
                  }
                });
              };

              let blob;
              try {
                blob = await render(false);
              } catch (firstError) {
                console.warn(
                  "通常のPNG描画に失敗したため再試行します。",
                  firstError,
                );
                blob = await render(true);
              }

              const fileName = `event_${this.pad(this.year, 4)}-${this.pad(
                this.month,
              )}-${this.pad(this.date)}.png`;
              this.closeSavePreview();
              this.savePreviewFileName = fileName;
              this.savePreviewUrl = URL.createObjectURL(blob);
            } catch (e) {
              console.error(e);
              alert(
                "PNGの作成に失敗しました。ページを再読み込みしてもう一度お試しください。改善しない場合は、index.htmlをローカルサーバー経由で開いてください。",
              );
            } finally {
              if (restoreImages) {
                restoreImages.mainElement.src = restoreImages.mainSrc;
                restoreImages.mainElement.style.objectFit =
                  restoreImages.mainObjectFit;
                restoreImages.mainElement.style.objectPosition =
                  restoreImages.mainObjectPosition;
                restoreImages.eventElement.src = restoreImages.eventSrc;
                restoreImages.logoElement.src = restoreImages.logoSrc;
              }
              this.suppressImageLoad = false;
              this.scale = old;
              this.exporting = false;
            }
          },
        },
      });
